import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { API_URL } from "../config/general.config";
import { Observable } from "rxjs";
import { BuildInfoModel, UserModel } from '../model/general.model';
import { Task } from "../modules/go/model/task.model";
import { UserSettings } from '../model/settings.model';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  private _userApi = API_URL + '/users';
  private _meApi = this._userApi + '/me';
  private taskApi = API_URL + '/tasks/';
  private _settingsApi = this._meApi + '/settings';

  constructor(
    private _http: HttpClient
  ) { }

  getLoggedUser(): Observable<UserModel> {
    return this._http.get<UserModel>(this._meApi);
  }

  getTask(id: number): Observable<Task> {
    return this._http.get<Task>(this.taskApi + id);
  }

  getUserSettings(): Observable<UserSettings[]> {
    return this._http.get<UserSettings[]>(this._settingsApi);
  }


  saveSetting(key: string, value: string): Observable<UserSettings> {
    return this._http.put<UserSettings>(this._settingsApi, { key, value });
  }

  getBuildInfo(): Observable<BuildInfoModel> {
    return this._http.get<BuildInfoModel>(API_URL + '/build-info');
  }
}
